var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3530_8702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6 1H2.4C1.63 1 1 1.63 1 2.4V10.8C1 11.57 1.63 12.2 2.4 12.2H12.2L15 15V2.4C15 1.63 14.37 1 13.6 1ZM11.5 9.4H4.5C4.115 9.4 3.8 9.085 3.8 8.7C3.8 8.315 4.115 8 4.5 8H11.5C11.885 8 12.2 8.315 12.2 8.7C12.2 9.085 11.885 9.4 11.5 9.4ZM11.5 7.3H4.5C4.115 7.3 3.8 6.985 3.8 6.6C3.8 6.215 4.115 5.9 4.5 5.9H11.5C11.885 5.9 12.2 6.215 12.2 6.6C12.2 6.985 11.885 7.3 11.5 7.3ZM11.5 5.2H4.5C4.115 5.2 3.8 4.885 3.8 4.5C3.8 4.115 4.115 3.8 4.5 3.8H11.5C11.885 3.8 12.2 4.115 12.2 4.5C12.2 4.885 11.885 5.2 11.5 5.2Z",
    fill: "#825AC8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3530_8702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewComment);
export default __webpack_public_path__ + "static/media/new-comment.980ac2611029447933cfc7ddfe66fd84.svg";
export { ForwardRef as ReactComponent };